import { useFormik } from "formik";
import ModalComponent from "..";
import { useChangePasswordMutation } from "../../../redux/features/auth/auth.api";
import { ModalCompProps } from "../../../utils/types";
import { ChangePasswordSchema } from "../../../utils/validations";
import { Button } from "../../buttons/button";
import { Icon } from "../../icon/icon";
import { TextInput } from "../../inputs/textInput";
import { MiniHeader } from "../../typography/miniHeader";

export const ChangePasswordModal = ({
  open,
  handleClose,
  onSuccess,
}: ModalCompProps & {
  onSuccess: () => void;
}) => {
  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
    resetForm,
  } = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
      oldPassword: "",
    },
    enableReinitialize: true,
    validationSchema: ChangePasswordSchema,
    onSubmit: async (vals) => {
      const resp = await changePassword({
        oldPassword: vals.oldPassword,
        password: vals.password,
      });

      if (resp.data?.status === "success") {
        onSuccess();
        resetForm();
      }
    },
  });

  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
        resetForm();
      }}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader={false}
      title={undefined}
      subtitle={undefined}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <Icon
          svg={"padlock"}
          width={42}
          height={42}
          className="rounded-xl border border-grey-100 p-[11px] text-grey-400"
        />

        <div>
          <MiniHeader
            header={`Change Password`}
            subheader="Type your current password to update it."
          />
        </div>

        <TextInput
          type="password"
          value={values.oldPassword}
          hasTitle
          title="Old Password"
          placeholder=""
          onBlur={handleBlur}
          onChange={handleChange}
          name="oldPassword"
          readOnly={false}
          errors={
            touched.oldPassword && errors.oldPassword
              ? errors.oldPassword
              : undefined
          }
        />

        <TextInput
          type="password"
          value={values.password}
          hasTitle
          title="New Password"
          placeholder=""
          onBlur={handleBlur}
          onChange={handleChange}
          name="password"
          readOnly={false}
          errors={
            touched.password && errors.password ? errors.password : undefined
          }
        />

        <TextInput
          type="password"
          value={values.confirmPassword}
          hasTitle
          title="Confirm Password"
          placeholder=""
          onBlur={handleBlur}
          onChange={handleChange}
          name="confirmPassword"
          readOnly={false}
          errors={
            touched.confirmPassword && errors.confirmPassword
              ? errors.confirmPassword
              : undefined
          }
        />

        <div className="flex w-full items-center justify-end gap-2">
          <Button
            text={"Cancel"}
            type="button"
            onClick={() => {
              handleClose();
              resetForm();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Change Password"}
            type="submit"
            onClick={() => {}}
            className="max-w-fit"
            loading={isLoading}
            disabled={isLoading}
            variation={"primary"}
          />
        </div>
      </form>
    </ModalComponent>
  );
};
